import { render } from "./ModalLoading.vue?vue&type=template&id=0225cf0f&scoped=true"
import script from "./ModalLoading.vue?vue&type=script&lang=js"
export * from "./ModalLoading.vue?vue&type=script&lang=js"

import "./ModalLoading.vue?vue&type=style&index=0&id=0225cf0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225cf0f"]])

export default __exports__